/* La La La service pricing. Theme-side protection; server validation is separate. */
(function (scope) {
  'use strict';
  const IDS = { small: 57073227628884, large: 57073227661652, wrap: 57073227694420 };
  const serviceIds = new Set(Object.values(IDS));
  const value = (p, key) => String(p?.[key] || '').trim();
  const yes = (p, key) => value(p, key).toLowerCase() === 'yes';
  function required(properties) {
    const p = properties || {};
    const result = [];
    if (yes(p, 'Personalisation requested')) {
      const match = /^(Classic|Script) (Small|Large) - £(15|25)$/.exec(value(p, 'Embroidery font'));
      if (!match || (match[2] === 'Small' ? match[3] !== '15' : match[3] !== '25'))
        throw new Error('Please remove this item and add it again with a valid embroidery selection.');
      const text = value(p, 'Embroidery text');
      if (!text || text.length > (match[2] === 'Small' ? 4 : 2) || !value(p, 'Thread colour'))
        throw new Error('Please complete the embroidery text and thread colour before adding this item.');
      result.push(IDS[match[2].toLowerCase()]);
    } else if (value(p, 'Embroidery text')) {
      throw new Error('Please confirm your personalisation, or clear the embroidery text.');
    }
    if (yes(p, 'Luxury gift wrap requested')) result.push(IDS.wrap);
    else if (value(p, 'Gift wrap message'))
      throw new Error('Please confirm gift wrap, or clear the gift message.');
    return result;
  }
  function buildItems(formData, group) {
    if (serviceIds.has(Number(formData.get('id'))))
      throw new Error('Please choose personalisation or gift wrap on your blanket product page. These services cannot be purchased separately.');
    const properties = {};
    for (const [key, entry] of formData.entries()) {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match) {
        if (typeof entry !== 'string') throw new Error('File uploads need a separate product form integration.');
        properties[match[1]] = entry;
      }
    }
    const services = required(properties);
    // Unconfirmed modal defaults are not order instructions. Validate first so
    // meaningful unconfirmed text still prompts the customer instead of vanishing.
    if (!yes(properties, 'Personalisation requested')) {
      for (const key of ['Personalisation requested', 'Personalisation price', 'Embroidery font', 'Embroidery text', 'Thread colour']) {
        delete properties[key];
        formData.delete(`properties[${key}]`);
      }
    }
    if (!yes(properties, 'Luxury gift wrap requested')) {
      for (const key of ['Luxury gift wrap requested', 'Gift wrap message']) {
        delete properties[key];
        formData.delete(`properties[${key}]`);
      }
    }
    if (!services.length) return null;
    const quantity = Number(formData.get('quantity') || 1);
    const id = Number(formData.get('id'));
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0)
      throw new Error('Please choose a valid product and quantity.');
    properties._lalala_group = group;
    const parent = { id, quantity, properties };
    if (formData.get('selling_plan')) parent.selling_plan = formData.get('selling_plan');
    return [parent, ...services.map(service => ({
      id: service, quantity, properties: { _lalala_group: group, _lalala_service: '1' }
    }))];
  }
  // Return one correction, then read again: Shopify line keys can change after any write.
  function nextCorrection(cart, makeGroup) {
    const expected = new Map();
    for (const item of cart.items) {
      if (serviceIds.has(Number(item.variant_id))) continue;
      const services = required(item.properties);
      if (!services.length) continue;
      const group = value(item.properties, '_lalala_group');
      if (!group) return { path: 'cart/change.js', body: {
        id: item.key, quantity: item.quantity,
        properties: { ...item.properties, _lalala_group: makeGroup() }
      } };
      for (const id of services) {
        const key = `${group}/${id}`;
        const entry = expected.get(key) || { id, quantity: 0, properties: { _lalala_group: group, _lalala_service: '1' } };
        entry.quantity += item.quantity;
        expected.set(key, entry);
      }
    }
    const existing = new Map();
    for (const item of cart.items.filter(item => serviceIds.has(Number(item.variant_id)))) {
      const key = `${value(item.properties, '_lalala_group')}/${item.variant_id}`;
      // These three variants are reserved add-ons, including old unlinked test lines.
      if (!expected.has(key)) return { path: 'cart/change.js', body: { id: item.key, quantity: 0 } };
      const lines = existing.get(key) || [];
      lines.push(item);
      existing.set(key, lines);
    }
    for (const [key, wanted] of expected) {
      const lines = existing.get(key) || [];
      const actual = lines.reduce((sum, item) => sum + item.quantity, 0);
      if (actual > wanted.quantity) {
        const line = lines[lines.length - 1];
        return { path: 'cart/change.js', body: { id: line.key, quantity: Math.max(0, line.quantity - (actual - wanted.quantity)) } };
      }
      if (actual < wanted.quantity) return { path: 'cart/add.js', body: {
        items: [{ ...wanted, quantity: wanted.quantity - actual }]
      } };
    }
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { IDS, required, buildItems, nextCorrection };
  if (!scope.document) return;
  const root = () => scope.Shopify?.routes?.root || '/';
  const cartUrl = () => root() + 'cart';
  const groupId = () => scope.crypto.randomUUID();
  let queue = Promise.resolve();
  let checkingOut = false;
  let navigating = false;
  let pending = 0;
  function message(text) {
    let box = document.getElementById('lalala-service-status');
    if (!box) {
      box = document.createElement('div');
      box.id = 'lalala-service-status';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;bottom:16px;left:16px;right:16px;z-index:10000;background:#fff;color:#222;border:2px solid #333;padding:16px;box-shadow:0 2px 12px #0003';
      document.body.append(box);
    }
    box.textContent = text;
    box.hidden = !text;
  }
  function exclusive(work) {
    pending++;
    document.documentElement.classList.add('lalala-cart-busy');
    const result = queue.then(work);
    queue = result.catch(() => {}).finally(() => {
      if (--pending === 0) document.documentElement.classList.remove('lalala-cart-busy');
    });
    return result;
  }
  async function request(path, body) {
    const response = await fetch(root() + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      signal: AbortSignal.timeout(20000),
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status || data.errors)
      throw new Error(typeof data.description === 'string' ? data.description : 'Your basket could not be updated. Please review it and try again.');
    return data;
  }
  async function reconcile() {
    let changed = false;
    for (let attempt = 0; attempt < 100; attempt++) {
      const cart = await request('cart.js');
      const correction = nextCorrection(cart, groupId);
      if (!correction) return { cart, changed };
      await request(correction.path, correction.body);
      changed = true;
    }
    throw new Error('Your basket is still changing. Please refresh it before checking out.');
  }
  async function checkout() {
    if (checkingOut) return;
    checkingOut = true;
    message('Checking your basket and personalisation charges…');
    try {
      await exclusive(async () => {
        if (navigating) return;
        // Commit quantity edits even when Enter/click happens before Dawn's debounce.
        let edited = false;
        const inputs = [...document.querySelectorAll('input[name="updates[]"][data-lalala-key]')];
        const seen = new Set();
        for (const input of inputs) {
          if (input.value === input.defaultValue || seen.has(input.dataset.lalalaKey)) continue;
          const quantity = Number(input.value);
          if (!input.checkValidity() || !Number.isSafeInteger(quantity) || quantity < 0)
            throw new Error('Please enter a valid quantity in your basket.');
          seen.add(input.dataset.lalalaKey);
          await request('cart/change.js', { id: input.dataset.lalalaKey, quantity });
          edited = true;
        }
        const result = await reconcile();
        if (!result.cart.item_count) throw new Error('Your basket is empty.');
        if (result.changed || edited || location.pathname.replace(/\/$/, '') !== cartUrl().replace(/\/$/, '')) {
          // Review corrected totals on a fresh, server-rendered cart before continuing.
          navigating = true;
          location.assign(cartUrl());
          return;
        }
        navigating = true;
        location.assign(root() + 'checkout');
      });
    } catch (error) { message(error.message + ' Checkout has not been opened.'); }
    finally { checkingOut = false; }
  }
  scope.LaLaLaServices = {
    buildItems: data => buildItems(data, groupId()),
    async add(items) {
      return exclusive(async () => {
        try {
          await request('cart/add.js', { items });
          await reconcile();
        } catch (error) {
          // Never retry an add blindly: the server may already have accepted it.
          message('We could not confirm the addition. Open your basket to check it before adding again. ' + error.message);
          throw error;
        }
      });
    },
    fetch: (url, config) => exclusive(async () => {
      const response = await fetch(url, config);
      await response.clone().text();
      return response;
    }),
    async change(key, quantity, config) {
      return exclusive(async () => {
        delete config.line;
        const data = await request('cart/change.js', { ...config, id: key, quantity });
        const result = await reconcile();
        if (result.changed) {
          navigating = true;
          location.assign(cartUrl());
          return null;
        }
        return data;
      });
    },
    error: error => message(error.message || 'Please review your basket and try again.'),
    checkout
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lalala-checkout], [name="checkout"], a[href]');
    if (!button) return;
    const linkIsCheckout = button.tagName === 'A' && /\/checkouts?(?:\/|$)/.test(new URL(button.href, location.href).pathname);
    if (!button.matches('[data-lalala-checkout], [name="checkout"]') && !linkIsCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
  document.addEventListener('submit', event => {
    if (!['cart', 'CartDrawer-Form', 'cart-notification-form'].includes(event.target.id)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
  function start() {
    document.querySelectorAll('[data-lalala-checkout]').forEach(button => { button.disabled = false; });
    if (location.pathname.replace(/\/$/, '') === cartUrl().replace(/\/$/, '')) {
      exclusive(reconcile).then(result => {
        if (result.changed) { navigating = true; location.reload(); }
      }).catch(error => message(error.message + ' Please correct your basket before checkout.'));
    }
  }
  // Delegated click handlers also cover buttons replaced by Dawn's section rendering.
  new MutationObserver(() => {
    document.querySelectorAll('[data-lalala-checkout][disabled]').forEach(button => { button.disabled = false; });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window === 'undefined' ? globalThis : window);
